import React from 'react'
import { useAPIContext } from '../../context/api'
import { ExternalMetadataAPI } from '../../../../constructs/external-metadata/interface'
import { MediaData } from '../../../../types/media-data'
import { SUPPORTED_PLATFORMS } from '../../constants/media-platform'
import sanitizeUrl from '../../utils/url-sanitizer'

export const useExternalMediaMetadata = () => {
  const { callEndpoint } = useAPIContext()

  const fetchExternalMetadata = React.useCallback(
    async (urls: string[]): Promise<MediaData[]> => {
      const sanitizedUrls = urls.reduce<string[]>((acc, url) => {
        if (SUPPORTED_PLATFORMS.instagram.match(url)) {
          acc.push(sanitizeUrl(url))
        } else if (SUPPORTED_PLATFORMS.tiktok.match(url)) {
          acc.push(url)
        }
        return acc
      }, [])

      if (sanitizedUrls.length === 0) return []

      try {
        const response = await callEndpoint<ExternalMetadataAPI, 'get-metadata'>('external-metadata', '', 'POST', {
          externalUrls: sanitizedUrls,
        })

        return response.map(({ mediaUrl, thumbnail = '', caption = '' }) => ({
          mediaUrl,
          thumbnail,
          caption,
        }))
      } catch (error) {
        console.error('Error fetching URL data:', error)
        return []
      }
    },
    [callEndpoint],
  )

  return { fetchExternalMetadata }
}
